import {
    AdapterRegistry,
    type IModel,
    type ITridentResource,
    KustoDatabaseLinkedService,
    Metamodel
} from 'shell-models-lib';
import { AzureDataExplorerLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-data-explorer-linkedservice.adapter';
import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(KustoDatabaseLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                workspaceId: '*',
                endpoint: '*',
                database: '*'
            },
            parameters: '*'
        }
    }
})
export class KustoDatabaseLinkedServiceAdapter extends AzureDataExplorerLinkedServiceAdapter {
    public override getArtifactId(resource: Model.LinkedServiceResource): string {
        return resource?.properties.typeProperties?.database;
    }

    protected override toAzureTypeProperties = (
        tridentResource: ITridentResource
    ): Model.KustoDatabaseLinkedServiceTypeProperties => ({
        workspaceId: tridentResource.workspaceObjectId,
        endpoint: tridentResource.extendedProperties?.QueryServiceUri as string,
        database: tridentResource.objectId
    });

    protected modelConstructor(): new () => KustoDatabaseLinkedService {
        return KustoDatabaseLinkedService;
    }

    protected model(): IModel {
        return KustoDatabaseLinkedService.MODEL;
    }

    protected override async propertiesToResourceAsync(
        linkedService: KustoDatabaseLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.KustoDatabaseLinkedService;

        properties.type = this.model().name;
        properties.typeProperties = {
            workspaceId: this.valueToResource(linkedService, KustoDatabaseLinkedService.WORKSPACE_ID),
            endpoint: this.valueToResource(linkedService, this.model().attribute('endpoint')),
            database: this.valueToResource(linkedService, KustoDatabaseLinkedService.ARTIFACT_ID)
        };

        return linkedServiceResource;
    }

    protected override async propertiesToModelAsync(
        linkedServiceResource: Model.LinkedServiceResource,
        linkedService: KustoDatabaseLinkedService
    ): Promise<KustoDatabaseLinkedService> {
        const properties = linkedServiceResource.properties as Model.KustoDatabaseLinkedService;
        const typeProperties: Model.KustoDatabaseLinkedServiceTypeProperties = properties.typeProperties;

        ValueAdapter.toModel(linkedService, KustoDatabaseLinkedService.WORKSPACE_ID, typeProperties.workspaceId);
        ValueAdapter.toModel(linkedService, this.model().attribute('endpoint'), typeProperties.endpoint);
        ValueAdapter.toModel(linkedService, KustoDatabaseLinkedService.ARTIFACT_ID, typeProperties.database);

        return linkedService;
    }
}
